import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
// [[Modulos da Aplicação]]
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from '~components/pagination/pagination.module';
import { TranslatePipeModule } from '~pipes/translate';
// []
// [Shared/Include/Product]
import { IncludeProductContainerModule } from '~project/shared/components/include/product/container/module';
// [[PrimeNg]
import { SidebarModule } from 'primeng/sidebar';
import { ToastModule } from 'primeng/toast';
import { GalleriaModule } from 'primeng/galleria';
import { SkeletonModule } from 'primeng/skeleton';
import { CheckboxModule } from 'primeng/checkbox';
import { AccordionModule } from 'primeng/accordion';
// []
// [[Providers/Services da Aplicação]]
import { ErrorService } from '~services/error.service';
import { ClientMarketplaceCoreSpecialService } from '~services/collective/client/marketplace/core/special/special.service';
import { ClientMarketplaceCoreSpecialRelProductService } from '~services/collective/client/marketplace/core/special/relproduct/relproduct.service';
import { ClientMarketplaceCoreHelpArticleService } from '~services/collective/client/marketplace/core/help/article.service';
import { CustomerProductAnalyticActionService } from '~services/panel/client/marketplace/customer/product/analytic/action.service';
import { CollectiveMarketplaceCoreSubscriptionKitService } from '~services/collective/client/marketplace/core/subscription/kit/subscription-kit.service';
import { CollectiveMarketplaceCartSubscriptionKitService } from '~services/collective/client/marketplace/cart/cart-subscription-kit.service';
import { ClientMarketplaceCoreVoucherService } from '~services/collective/client/marketplace/core/voucher/voucher.service';
// []
// [[Rotas da Aplicação]]
import { ModuleRoutes } from './routing';
// []
// [[Componentes da Aplicação]]
import {
  AboutUsComponent,
  HomeComponent,
  SearchComponent,
  SalesmanComponent,
  SpecialViewComponent,
  SubscriptionComponent,
  // [Kit]
  SubscriptionKitViewComponent,
  // [Voucher]
  VoucherViewComponent,
} from './index';
// []
@NgModule({
  imports: [
    LoadingBarHttpClientModule,
    CommonModule,
    RouterModule.forChild(ModuleRoutes),
    FormsModule,
    ReactiveFormsModule,
    SidebarModule,
    ToastModule,
    GalleriaModule,
    SkeletonModule,
    CheckboxModule,
    AccordionModule,
    PaginationModule,
    // ProgressbarModule,
    // CarouselModule,
    TranslatePipeModule,
    // [Shared/Include/Product]
    IncludeProductContainerModule,
  ],
  declarations: [
    AboutUsComponent,
    HomeComponent,
    SearchComponent,
    SalesmanComponent,
    SpecialViewComponent,
    SubscriptionComponent,
    // [Kit]
    SubscriptionKitViewComponent,
    // [Voucher]
    VoucherViewComponent,
  ],
  providers: [ErrorService, ClientMarketplaceCoreSpecialService, ClientMarketplaceCoreSpecialRelProductService, ClientMarketplaceCoreHelpArticleService, CustomerProductAnalyticActionService, CollectiveMarketplaceCoreSubscriptionKitService, CollectiveMarketplaceCartSubscriptionKitService, ClientMarketplaceCoreVoucherService],
})
export class WwwModule {
  constructor() {}
}
